<template>
  <div class="promo">
    <header class="promo__header">
      <div class="promo__title">Đăng ký và nhận 70,000 miễn phí</div>
      <div class="promo__header-spacer"></div>
    </header>

    <main class="promo__content">
      <section class="promo__panel">
        <div class="promo__top">
          <div class="promo__qr">
            <div ref="qrcode" class="promo__qrCode" aria-label="QR"></div>
            <div class="promo__qr-caption">Lưu mã mời</div>
          </div>

          <div class="promo__shareBox">
            <div class="promo__urlRow">
              <div class="promo__urlText">{{ url }}</div>
              <i class="el-icon-copy-document" v-clipboard:copy="url" v-clipboard:success="copySuccess"></i>
            </div>

            <div class="promo__shareRow">
              <button class="promo__shareItem" type="button" @click="goServer">
                <img src="@/assets/img_server.png" class="promo__shareIcon" />
                server</button>
            </div>
          </div>
        </div>
      </section>

      <section class="promo__links">
        <a class="promo__link" :href="downloadUrl" target="_blank" rel="noopener">👉 Download the app</a>
        <a class="promo__link" :href="serverUrl" target="_blank" rel="noopener">👉 Telegram Official channel</a>
        <a class="promo__link" :href="serverUrl" target="_blank" rel="noopener">👉 WhatsApp Official channel</a>
      </section>

      <section class="promo__section">
        <div class="promo__sectionTitle">Chi tiết sự kiện:</div>
        <div class="promo__sectionText">
          Tham gia ngay FE88.COM, chỉ tải ứng dụng về di động và hoàn thành các nhiệm vụ để nhận 59K ;chỉ dành cho
          casino và thể thao
        </div>
      </section>

      <section class="promo__tableWrap">
        <table class="promo__table">
          <thead>
            <tr>
              <th>YÊU CẦU HOẠT ĐỘNG</th>
              <th>GIÁ TRỊ PHẦN THƯỞNG</th>
              <th>YÊU CẦU RÚT TIỀN</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Theo dõi, like, chia sẻ bài viết fanpage vào<br>3 hội nhóm khác nhau trên FB</td>
              <td class="promo__money">15K</td>
              <td rowspan="4" class="promo__withdraw">
                5 vòng cược<br>
                Casino và Thể Thao
              </td>
            </tr>
            <tr>
              <td>Đăng ký tài khoản</td>
              <td class="promo__money">9K</td>
            </tr>
            <tr>
              <td>Tải ứng dụng về di động và đăng nhập tài khoản thành viên</td>
              <td class="promo__money">25K</td>
            </tr>
            <tr>
              <td>Liên kết số điện thoại và thẻ ngân hàng vào app</td>
              <td class="promo__money">10K</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="promo__footer">
        <div class="promo__footerText">
          Lưu ý: nếu trong quá trình chơi, người chơi vi phạm các trò không có trong yêu cầu thì bên công ty chúng tôi
          sẽ vô hiệu hóa số tiền thưởng mình đã thắng cược.
        </div>
        <div class="promo__sectionTitle promo__sectionTitle--spaced">Chi tiết sự kiện:</div>
        <ol class="promo__ol">
          <li>1. Tiền thưởng nhiệm vụ cần gấp 20 lần khối lượng trò chơi để được rút;</li>
          <li>2. Các loại trò chơi sau: [Baccarat, Red and Black War, Dragon and Tiger Fight, Sic Bo] sẽ không được tham
            gia chương trình khuyến mãi này, nếu không tiền thưởng và tiền thắng cược sẽ bị vô hiệu. Nếu xảy ra chênh
            lệch giá trong Baccarat hoặc bất kỳ trò chơi nào khác, công ty chúng tôi có quyền hủy bỏ tất cả tiền thắng
            cược của bạn.</li>
          <li>3. Số tài khoản ngân hàng và bất kỳ thông tin nào không thể thay đổi trước yêu cầu rút tiền đầu tiên. Nếu
            cần phải sửa đổi, tiền thưởng quà tặng và lợi nhuận do tiền thưởng tạo ra sẽ bị khấu trừ;</li>
          <li>4. Mỗi thành viên và mỗi địa chỉ IP chỉ được tham gia một lần. Nếu nhiều tài khoản sử dụng cùng một địa
            chỉ IP, chúng sẽ được coi là cùng một người và không thể tham gia lại;</li>
          <li>5. Nếu bạn quên số tài khoản thành viên/mật khẩu, vui lòng liên hệ với "dịch vụ khách hàng trực tuyến 24
            giờ" để được hỗ trợ khôi phục thông tin tài khoản của mình;</li>
          <li>6. FE88.COM có quyền sửa đổi, ngừng hoặc hủy chương trình khuyến mãi này bất kỳ lúc nào.</li>
        </ol>
      </section>
    </main>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'

export default {
  name: 'HomeView',
  data() {
    return {
      url: 'https://fe88l.vip/',
      downloadUrl: 'https://app.001bet0.com/#/download',
      serverUrl: 'https://www.dotesa.cfd/chat/index?channelId=bd186d2637594c3396aa15a32654b311'
    }
  },
  mounted() {
    this.renderQrCode()
  },
  watch: {
    url() {
      this.renderQrCode()
    }
  },
  methods: {
    renderQrCode() {
      const el = this.$refs.qrcode
      if (!el) return

      while (el.firstChild) {
        el.removeChild(el.firstChild)
      }

      // eslint-disable-next-line no-new
      new QRCode(el, {
        text: this.url,
        width: 50,
        height: 50,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.M
      })
    },
    copySuccess() {
      this.$toast('Copy success')
    },
    goServer() {
      window.open('https://www.dotesa.cfd/chat/index?channelId=bd186d2637594c3396aa15a32654b311', '_blank')
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.back()
        return
      }
      this.$router.push('/')
    },
    async copyUrl() {
      const text = this.url
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text)
          return
        }
      } catch (e) {
        void e
      }
      const input = document.createElement('input')
      input.value = text
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
    }
  }
}
</script>

<style scoped>
.promo {
  max-width: 500px;
  min-height: 100vh;
  background: #b30000;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
}

.promo__header {
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 12px;
  background: #c10000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  z-index: 10;
}

.promo__back {
  width: 36px;
  height: 36px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: transparent;
  color: #fff;
  font-size: 22px;
  line-height: 34px;
  cursor: pointer;
}

.promo__title {
  flex: 1;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  padding: 0 8px;
}

.promo__header-spacer {
  width: 36px;
  height: 36px;
}

.promo__content {
  padding: 12px;
}

.promo__panel {
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.06);
  padding: 10px;
}

.promo__top {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 12px;
  align-items: stretch;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(0, 0, 0, 0.08);
}

.promo__qr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 10px;
  text-align: center;
}

.promo__qrCode {
  width: 90px;
  height: 90px;
  margin: 0 auto;
  border-radius: 6px;
  overflow: hidden;
  background: #ffffff;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.promo__qr-caption {
  margin-top: 8px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
}

.promo__shareBox {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.promo__urlRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  padding: 4px 8px;
}

.promo__urlText {}

.promo__iconBtn {
  height: 40px;
  width: 40px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.promo__shareRow {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.promo__shareHint {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-right: 4px;
}

.promo__shareItem {
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  background: transparent;
  border: none;
  padding: 0;
  appearance: none;
}

.promo__shareIcon {

  width: 60px;

  height: 60px;

  object-fit: contain;
  margin-bottom: 4px;

}

.promo__shareItem--telegram {
  /* background: rgba(30, 136, 229, 0.2); */
}

.promo__shareItem--zalo {
  background: rgba(33, 150, 243, 0.2);
}

.promo__shareItem--facebook {
  background: rgba(59, 89, 152, 0.25);
}

.promo__links {
  margin-top: 12px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.08);
}

.promo__link {
  display: block;
  color: #ffd54f;
  text-decoration: none;
  font-weight: 700;
  margin: 6px 0;
  word-break: break-word;
}

.promo__section {
  margin-top: 12px;
  padding: 12px;
}

.promo__sectionTitle {
  font-weight: 800;
  color: #ffe082;
  margin-bottom: 8px;
}

.promo__sectionTitle--spaced {
  margin-top: 14px;
}

.promo__sectionText {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
}

.promo__tableWrap {
  margin-top: 6px;
}

.promo__table {
  width: 100%;
  border-collapse: collapse;
  overflow: hidden;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.08);
}

.promo__table th,
.promo__table td {
  border: 1px solid rgba(255, 255, 255, 0.14);
  padding: 10px;
  text-align: center;
  vertical-align: top;
  font-size: 14px;
  line-height: 1.35;
  vertical-align: middle;
}

.promo__table th {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-weight: 800;
}

.promo__money {
  text-align: center;
  font-weight: 800;
  color: #ffe082;
  white-space: nowrap;
}

.promo__withdraw {
  color: rgba(255, 255, 255, 0.95);
}

.promo__sub {
  color: #9cff57;
  font-weight: 800;
}

.promo__footer {
  padding: 12px;
  margin-top: 6px;
}

.promo__footerText {
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
}

.promo__ol {
  margin: 10px 0 0;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.95);
}
</style>
